import { Mail } from "lucide-react";
import { useAuthStep } from "@/hooks/useAuthStep";
import { GoogleSvg, OutlookSvg } from "@/lib/svg";
import { useCommunication } from "@/lib/CommunicationWrapper";

const LastUsedTag = () => {

    return (
        <div className="absolute -top-[6px] -right-[10px] bg-black text-white text-xs px-2 py-1 rounded-full">
            Last used
        </div>
    )
}

const Logins = () => {
    const { setAuthStep } = useAuthStep();
    const lastUsed = localStorage.getItem("last_used_login_method");

    const { origin } = useCommunication();

    return (
        <div className="px-[30px] flex flex-col h-full">
            <div>
                <h1 className="text-2xl font-semibold mb-[5px]">Log in to BetterCampus</h1>
                <p className="text-gray-500">Over 1.5 million students made their Canvas better</p>
            </div>
            <div className="flex flex-col gap-[10px] mt-[10px]">
                <button onClick={() => setAuthStep("googleLogin")} className="relative hover:bg-gray-100 transition-all duration-200 shadow-xs flex justify-center items-center rounded-xl w-full p-3.5 border border-[#e5e5e5] gap-[10px] font-medium">
                    {lastUsed === "google" && <LastUsedTag />}
                    <GoogleSvg className="w-[20px] h-[20px]" />
                    <span>Continue with Google</span>
                </button>

                <div>
                    <button onClick={() => setAuthStep("outlookLogin")} className="relative hover:bg-gray-100 transition-all duration-200 shadow-xs flex justify-center items-center rounded-xl w-full p-3.5 border border-[#e5e5e5] gap-[10px] font-medium">
                        {lastUsed === "outlook" && <LastUsedTag />}
                        <OutlookSvg className="w-[20px] h-[20px]" />
                        <span>Continue with Microsoft</span>
                    </button>
                </div>
            </div>
            <div className="my-4">
                <div className="h-[1px] bg-gray-200 w-full relative">
                    <div className="text-gray-500 text-center text-sm w-full h-full absolute left-0 top-0 flex items-center justify-center">
                        <span className="bg-white px-2 text-xs">OR</span>
                    </div>
                </div>
            </div>
            <div>
                <button onClick={() => setAuthStep("emailLogin")} className="hover:bg-gray-100 transition-all duration-200 shadow-xs flex justify-center items-center rounded-xl w-full p-3.5 border border-[#e5e5e5] gap-[10px] font-medium">
                    {lastUsed === "email" && <LastUsedTag />}
                    <Mail className="w-[20px] h-[20px]" />
                    <span>Continue with Email</span>
                </button>
            </div>
            <div className="flex flex-col gap-[10px] flex-1 mb-[30px]">
                <div className="mt-auto">
                    <button className="w-full  text-sm p-[10px] text-gray-500">
                        Don't have an account? <a href={`/signup?skipWelcome=true&signup=true&origin=${origin}`} className="underline font-medium text-black">Sign up</a>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Logins;
